// src\themes\lino\elements\Product\RelatedProducts.tsx
import { getRelatedProductsById } from "@/core/lib/api/main/main-shop-product";
import { getDictionaryServer } from "@/core/lib/dictionary";
import SwiperRelatedProducts from "./SwiperRelatedProducts";

type RelatedProductsProps = {
  productId: number;
};

export default async function RelatedProducts({
  productId,
}: RelatedProductsProps) {
  const relatedProduct = await getRelatedProductsById(productId);
  const { dictionary } = await getDictionaryServer()
  if (relatedProduct.related_products.length === 0) return null;

  return (
    <div className="w-full">
      <span className="block mb-8 text-[11px] uppercase tracking-[0.14em] text-primary-500 pb-4 border-b border-primary-900">
        {dictionary.forms?.related_products}
      </span>
      <SwiperRelatedProducts items={relatedProduct.related_products} />
    </div>
  );
}